import { IonToast } from '@ionic/react'
import React from 'react'
import { connect } from 'react-redux'
import { State } from '../store'
import { Notification, removeNotification, removeNotificationType } from '../store/notification'

interface StateProps {
  list: Notification[]
}

interface DispatchProps {
  removeNotification: removeNotificationType,
}

type Props = StateProps & DispatchProps;

const Notifications: React.FC<Props> = props => {
  return (
    <>
      {props.list.map((n, i) => (
        <IonToast
          position={'top'}
          key={n.index}
          isOpen={i === 0}
          onDidDismiss={() => props.removeNotification(n)}
          message={n.message}
          color={n.color || 'primary'}
          duration={n.duration || 2000}
        />
      ))}
    </>
  )
}

export default connect<StateProps, DispatchProps, {}, State>(
  ({notification}) => ({
    list: notification.list,
  }),
  {
    removeNotification
  }
)(Notifications)
